{
  "time": {
    "justNow": "Just now",
    "yesterday": "Yesterday",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago"
  },
  "panel": {
    "markAllRead": "Mark all read",
    "clearAll": "Clear all",
    "clearRead": "Clear read",
    "updating": "Updating…",
    "clearing": "Clearing…",
    "allRead": "All read",
    "unread": "{{count}} unread",
    "markedAllRead": "All notifications marked as read",
    "cleared": "Notifications cleared",
    "clearedRead": "Read notifications cleared",
    "actionFailed": "Notification action failed"
  }
}
